bcn.inputEditedClass = (function () {

  'use strict';

  return {
    init: function () {

      $('[data-input-edited-class]').each(function () {
        var input = $(this);
        var activeClass = input.data('input-edited-class');
        input.on('focus', function () {
          if (input.hasClass(activeClass)) {return;}
          input.addClass(input.data('input-edited-class'));
        });
      });

    }
  };

})();
